export default __webpack_public_path__ + "static/media/card.spec.js.3ff9fb63.map";